import { GetInfoFaqResponse } from "../../../types/api/info.type";
import httpClient from "../../client/HttpClient";

const InfoFaqService = {
  async list(): Promise<GetInfoFaqResponse> {
    const response = await httpClient.get<GetInfoFaqResponse>("v1/info/faq");
    return response;
  },
};

export default InfoFaqService;
